import React, { Suspense, useCallback } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { closeDrawer } from '../../redux/reducer/drawerSlice';
import PageLoader from '../loader/LoaderText';
import { RootState } from '../../redux/store';

const QuatationCreateForm = React.lazy(() => import('./quatation'));
const ProformaInvoiceComponent = React.lazy(() => import('./proforma-invoice'));

const CommonDrawerComponent = () => {
    const dispatch = useDispatch();
    const drawer = useSelector((state: RootState) => state.drawer);

    const DEFAULT_DRAWER_WIDTH = 1400;

    const drawerWidthMapping: Record<string, number> = {
        xl: 1200,
        lg: 1000,
        md: 800,
        sm: 600,
    };

    const getDrawerWidth = useCallback(() => {
        if (drawer.isFullScreen) return "100%";
        if (drawer.drawerWidth) return drawerWidthMapping[drawer.drawerWidth];
        return DEFAULT_DRAWER_WIDTH;
    }, [drawer.isFullScreen, drawer.drawerWidth, drawerWidthMapping]);

    const handleClose = useCallback(() => {
        dispatch(closeDrawer());
    }, [dispatch]);

    return (
        <Drawer
            anchor="right"
            open={drawer.open}
            sx={{
                '& .MuiBackdrop-root': {
                    backdropFilter: 'blur(2px) sepia(8%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                },
            }}
            PaperProps={{
                sx: {
                    maxWidth: getDrawerWidth(),
                    width: '100%',
                    boxShadow: 6,
                    overflowY: 'unset',
                    backgroundColor: 'background.paper',
                },
            }}
        >
            <Box
                sx={{
                    bgcolor: 'primary.main',
                    height: 59,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    px: 2,
                    boxShadow: 7,
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    padding: 2,
                }}
            >
                <Typography variant='h3' color='primary.contrastText'>{drawer.title}</Typography>
                <IconButton sx={{ color: 'primary.contrastText' }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box>
                <Suspense fallback={<PageLoader />}>
                    <QuatationCreateForm />
                    <ProformaInvoiceComponent />
                </Suspense>
            </Box>
        </Drawer>
    )
}

export default CommonDrawerComponent;